FAQMainView = require('./views/main')
FAQViewManagerView = require('./views/viewmanager')
FAQAppRouter = require('./Approuter')
SharedUtilsHelper = require('../../shared/frontend/helpers/utils')
SharedFooterUSMainView = require('../../shared/frontend/views/footer/US/main_view')

Date.now = Date.now || -> +new Date

unless (typeof String.prototype.trim is 'function')
  String.prototype.trim = () ->
    return this.replace(/^\s+|\s+$/g, '')

FAQ =
  createFaqNameSpace: ->
    window.Groupon ?= {}
    window.Groupon.FAQ ?= {}
    _.extend window, SharedUtilsHelper

$(document).ready ->
  FAQ.createFaqNameSpace()

  if checkIfIsUSByCountry(window.country?.name)
    footer = new SharedFooterUSMainView()
    footer.render()
    $("#footer-content").html(footer.el)
    toggleCallUs(0)

  if isCMSEnabled()
    Groupon.FAQ.ViewManager = new FAQViewManagerView()
    Groupon.FAQ.Router = new FAQAppRouter()
    Backbone.history.start({root:  window.FAQBASEURL})

  $('.help-wizard-menu').on('click', () ->
    window.location.href = "#{window.SUPPORTBASEURL}?fromFaq=true"
    return false
  )
  $('.faqs-menu').on('click', ->
    redirectToFaq()
    return false
  )
  Groupon.Performance.pageReady()
